export function OutlineCentrosComercialesIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.0028 11.3486L18.4728 14.3486H5.03282C4.41282 14.3486 3.86282 14.6286 3.49282 15.0786C3.35282 13.1086 3.21282 11.0186 3.09282 9.32864C3.07282 8.97864 3.05282 8.64864 3.03282 8.34864C2.86282 6.12864 3.38282 4.97864 3.91282 4.34864C5.90282 1.99864 11.2628 2.96864 15.0328 5.34864C17.1528 6.67864 18.7728 8.45864 19.0028 10.3486C19.0528 10.7786 19.0228 11.1386 19.0028 11.3486Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3.03271 9.34887C4.21271 8.84887 5.93271 8.31887 8.03271 8.34887C13.6727 8.42887 17.3227 12.5189 18.0327 13.3489"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0328 14.3486C9.55281 14.3086 9.09281 14.2886 8.64281 14.3086C8.38281 14.3186 8.13281 14.3286 7.88281 14.3486"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.03271 3.34766L8.31271 8.35766L8.64271 14.3077V14.3477"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.9131 14.3477L14.4131 10.2777V10.2677L15.0331 5.34766"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0327 21.3477V18.3477"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M17.0327 21.3477V18.3477"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M7.03271 21.3477V18.3477"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M21.0327 16.3477V19.3477C21.0327 20.4477 20.1327 21.3477 19.0327 21.3477H5.03271C3.93271 21.3477 3.03271 20.4477 3.03271 19.3477V16.3477C3.03271 15.8677 3.20271 15.4277 3.49271 15.0777C3.86271 14.6277 4.41271 14.3477 5.03271 14.3477H19.0327C20.1327 14.3477 21.0327 15.2477 21.0327 16.3477Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
